module.exports = __webpack_public_path__ + "media/images/country_flags/fk-c0b825c4414f54f10ec9cb89a166df67.png";